module.exports = __webpack_public_path__ + "img/jigou1.00ccbbbb.png";